export const EVENT_SOURCE = 'womens-events';
